import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function UpcomingBookings({ bookings = [] }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 7;

  const data = Array.isArray(bookings) ? bookings : [];
  const totalPages = Math.max(1, Math.ceil(data.length / pageSize));
  const currentData = data.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const startItem = data.length > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(currentPage * pageSize, data.length);

  return (
    <div className="dash-card p-2 d-flex flex-column justify-content-between" style={{ height: '100%', minHeight: 260 }}>
      <div className="d-flex flex-column flex-grow-1" style={{ width: '100%', minHeight: 0 }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-1 px-1">
          <h6 className="m-0 fw-bold" style={{ fontSize: '12.5px', color: '#0f172a' }}>
            Upcoming Bookings — Next 7 Days
          </h6>
          <button
            type="button"
            onClick={() => navigate('/Booking')}
            style={{
              fontSize: '11px',
              color: '#0d7a71',
              fontWeight: '700',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }}
          >
            View All
          </button>
        </div>

        {/* Table */}
        <div className="table-responsive flex-grow-1" style={{ width: '100%' }}>
          <table className="dash-pixel-table" style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '25%' }}>Date</th>
                <th style={{ width: '38%' }}>Company</th>
                <th style={{ width: '22%' }}>Booked By</th>
                <th style={{ width: '15%' }}>Vehicle</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-4" style={{ color: '#94a3b8', fontSize: '11px' }}>
                    No upcoming bookings found
                  </td>
                </tr>
              ) : currentData.map((row, i) => (
                <tr key={i}>
                  <td style={{ color: '#475569', fontWeight: '500' }}>{row.date}</td>
                  <td style={{ color: '#1e293b', fontWeight: '600' }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.company}>
                      {row.company}
                    </div>
                  </td>
                  <td style={{ color: '#475569' }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.bookedBy}>
                      {row.bookedBy}
                    </div>
                  </td>
                  <td style={{ color: '#475569' }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.vehicle}>
                      {row.vehicle}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Footer */}
      <div className="d-flex justify-content-between align-items-center mt-auto pt-1 border-top px-1" style={{ fontSize: '10px' }}>
        <span style={{ color: '#64748b' }}>
          {data.length > 0 ? `Showing ${startItem}–${endItem} of ${data.length}` : '0 of 0'}
        </span>
        <div className="d-flex align-items-center gap-1">
          <button
            type="button"
            className="dash-page-btn"
            disabled={currentPage <= 1}
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
          >
            ‹
          </button>
          <button
            type="button"
            className="dash-page-btn"
            disabled={currentPage >= totalPages}
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
          >
            ›
          </button>
        </div>
      </div>
    </div>
  );
}
